module.exports = __webpack_public_path__ + "img/piamy.f056875.png";